export async function waitForTourTargets(
  selectors: string[],
  timeout = 5000,
): Promise<void> {
  const start = performance.now();

  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      const allReady = selectors.every(sel => {
        const el = document.querySelector(sel);
        return el instanceof HTMLElement && el.offsetParent !== null;
      });

      if (allReady) {
        clearInterval(interval);
        resolve();
      }

      if (performance.now() - start > timeout) {
        clearInterval(interval);
        reject(new Error('Targets not found in time or not visible'));
      }
    }, 100);
  });
}
